/* eslint-disable */

import type { Address } from "viem"
import type { Config } from "wagmi"

import type { EmitEvent } from "@/domains/core"
import { EventEmitter } from "@/domains/library"
import { createGauge } from "@/domains/on-chain"

/** Contract revert reason when the pool's tokens are not whitelisted for gauges. */
const WHITELIST_ERROR_PATTERN = /!whitelisted|whitelist/i

interface CreateGaugeInteractionParams {
  account: Address
  chainId: number
  config: Config
  pairAddress: Address
  pairDisplayName: string
  voterAddress: Address
  emitter: EventEmitter<EmitEvent>
}

export const createGaugeInteraction = async ({
  account,
  chainId,
  config,
  pairAddress,
  pairDisplayName,
  voterAddress,
  emitter,
}: CreateGaugeInteractionParams) => {
  emitter.emit("creating-gauge", {
    title: "Create gauge",
    description: `Creating gauge for ${pairDisplayName} at ${pairAddress}`,
    variant: "info",
  })

  const result = await createGauge({
    account,
    chainId,
    config,
    pairAddress,
    voterAddress,
  })

  if (result.success) {
    emitter.emit("create-gauge", {
      title: "Create gauge",
      description: `Gauge created for ${pairDisplayName} at ${pairAddress}`,
      variant: "success",
    })
  }

  if (result.success === false) {
    const errorStr = typeof result.error === "string" ? result.error : ""
    const isWhitelistError = WHITELIST_ERROR_PATTERN.test(errorStr)

    emitter.emit("error-creating-gauge", {
      title: isWhitelistError ? "Tokens not whitelisted" : "Create gauge failed",
      description: isWhitelistError
        ? "One or both tokens in this pair must be whitelisted before a gauge can be created. Please try again once the tokens are whitelisted."
        : (result.error ?? "Unknown error"),
      variant: "error",
    })
  }

  return result
}
